export const PRODUCTION_CONFIG = {
  SERVER_URL: 'https://procyon.com/',
  DATA_SOURCE: 'SERVER', // LOCAL or SERVER,
  COMPANY_TITLE: 'PROCYON'
}
